import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDisabledInstitution = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_4608_10338)",
		children: [
			/* @__PURE__ */ _jsx("mask", {
				id: "mask0_4608_10338",
				style: { maskType: "luminance" },
				maskUnits: "userSpaceOnUse",
				x: 0,
				y: 0,
				width: 26,
				height: 26,
				children: /* @__PURE__ */ _jsx("path", {
					d: "M26 0H0V26H26V0Z",
					fill: "white"
				})
			}),
			/* @__PURE__ */ _jsxs("g", {
				mask: "url(#mask0_4608_10338)",
				children: [
					/* @__PURE__ */ _jsx("path", {
						d: "M2.25 9H21.75L12 3L2.25 9Z",
						stroke: "#6F6F6F",
						strokeWidth: 1.5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M5.25 9V16.5",
						stroke: "#6F6F6F",
						strokeWidth: 1.5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M9.75 9V16.5",
						stroke: "#6F6F6F",
						strokeWidth: 1.5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M14.25 9V16.5",
						stroke: "#6F6F6F",
						strokeWidth: 1.5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M18.75 9V16.5",
						stroke: "#6F6F6F",
						strokeWidth: 1.5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M3 16.5H21",
						stroke: "#6F6F6F",
						strokeWidth: 1.5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M1.5 19.5H22.5",
						stroke: "#6F6F6F",
						strokeWidth: 1.5,
						strokeLinecap: "round",
						strokeLinejoin: "round"
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M2 2.13672L24.0674 24.0742",
				stroke: "#6F6F6F",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4608_10338",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 26,
			height: 26,
			fill: "white"
		})
	}) })]
});
export default SvgDisabledInstitution;
